export const TRIGGER_TYPES = [
  {
    type: 'TIME',
    label: 'Time'
  },
  {
    type: 'PERCENTAGE',
    label: 'Percentage'
  },
  {
    type: 'INTERACTIVE_SECTION',
    label: 'Section'
  },
  {
    type: 'INTERACTIVE_DOWNLOAD',
    label: 'On Download'
  },
  {
    type: 'EXIT_INTENT',
    label: 'Exit Intent'
  }
]

export const LANDING_PAGE_TRIGGER = [
  {
    type: 'TIME',
    label: 'Time'
  },
  {
    type: 'PERCENTAGE',
    label: 'Percentage'
  },
  {
    type: 'EXIT_INTENT',
    label: 'Exit Intent'
  }
]

export const SPATIAL_TRIGGER = [
    {
      type: 'SPATIAL_SLIDE',
      label: 'Slide'
    },
    {
      type: 'TIME',
      label: 'Time'
    },
    {
      type: 'EXIT_INTENT',
      label: 'Exit Intent'
    }
]

export const ASSET_MAPPING_TRIGGER = [
  {
    type: 'TIME',
    label: 'Time'
  },
  {
    type: 'PERCENTAGE',
    label: 'Percentage'
  }
]
